

















































import { Button } from 'element-ui'
import NProgress from 'nprogress'
import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import BookingTopNav from '@/components/BookingTopNav.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import ReviewForm from '@/components/ReviewForm.vue'

import Review, { ReviewSubmitPayload } from '@/models/review'

import BookingHeaderTitleMixin from '@/mixins/BookingHeaderTitleMixin.vue'
import store from '@/store'
import { BookingsActionTypes } from '@/store/modules/bookings'
import { ReviewActionTypes } from '@/store/modules/reviews'
import { normalizeReviewQueryToken } from '@/utils/review-query-token'

@Component({
  components: {
    ReviewForm,
    BookingTopNav,
    [Button.name]: Button,
    LoadingPlaceholder,
  },
})
export default class ReviewPage extends mixins(BookingHeaderTitleMixin) {
  reviewSubmittedOnThisVisit = false // Cleared on load; set only after Submit succeeds — distinguishes revisit vs thank-you screen. */

  mounted() {
    this.initialSetup(this.$route.params.id)
  }

  beforeRouteUpdate(to: Route, from: Route, next: (to?: Location) => void) {
    if (to.name !== 'guestReview') {
      this.setHeaderTitle(to.params.id)
    }
    this.reviewSubmittedOnThisVisit = false
    this.initialSetup(to.params.id, to)
    next()
  }

  initialSetup(bookingId: string, route?: Route) {
    const r = route || this.$route
    const guest = r.name === 'guestReview'
    const token = normalizeReviewQueryToken(r.query.token)

    if (!guest && this.$store.getters.isLogined && !token) {
      this.$store.dispatch(BookingsActionTypes.Get, bookingId)
    }

    NProgress.start().set(0.6)
    store
      .dispatch(ReviewActionTypes.GetCustomerReview, {
        bookingId,
        token,
      })
      .finally(() => {
        NProgress.done()
      })
  }

  get isGuestReview(): boolean {
    return this.$route.name === 'guestReview'
  }

  get reviewTokenForApi(): string | undefined {
    return normalizeReviewQueryToken(this.$route.query.token)
  }

  get reviewFormInitialName(): string {
    if (this.reviewTokenForApi) {
      return this.customerReview?.displayName || ''
    }
    return this.customerFirstName
  }

  get customerReview(): Review | null {
    return this.$store.getters.getCurrentCustomerReview
  }

  get thankYouAfterFreshSubmit(): boolean {
    return this.reviewSubmittedOnThisVisit
  }

  get reviewLoaded(): boolean {
    return this.$store.state.reviews.reviewLoaded
  }

  get bookingId() {
    return this.$route.params.id
  }

  get customerFirstName(): string {
    const customer = this.$store.getters.getCurrentCustomer
    return customer?.firstName || ''
  }

  async submitReview(reviewData: ReviewSubmitPayload) {
    const { images, ...review } = reviewData
    const bookingId = this.bookingId
    await this.$store.dispatch(ReviewActionTypes.Submit, {
      review,
      bookingId,
      images: images || [],
      token: this.reviewTokenForApi,
    })
    this.reviewSubmittedOnThisVisit = true
  }

  onReviewFormValidationError() {
    this.$nextTick(() => {
      const formComponent = this.$refs.reviewFormComponent as any
      formComponent?.scrollToFirstValidationError?.()
    })
  }

  goToDashboard() {
    this.$router.push({ name: 'dashboard' })
  }

  onContinueThankYou() {
    if (this.isGuestReview) {
      window.location.href = this.marketingSiteUrl
    } else {
      this.goToDashboard()
    }
  }
}
